import { Button } from "@fluentui/react-components";
import { DocumentTableRegular } from "@fluentui/react-icons";
import { ExportExcelHandle } from "../InsurerReportEntriesGrid/ExportExcel";
import React from "react";
import { useTranslation } from "react-i18next";
import { useInsurerReportsStore } from "store/InsurerReportsStore";
import { InsurerReportEntry } from "types/insurerReports";

type Props = {
  refExcelExport: React.RefObject<ExportExcelHandle>;
};

export const ExportExcelButton = ({ refExcelExport }: Props) => {
  const { t } = useTranslation();
  const [
    {
      insurerReportsLoadStatus,
      insurerReportEntries,
      insurerReportEntryMetadataMap,
    },
  ] = useInsurerReportsStore();

  // Nothing to export while no entry row is on screen.
  const hasVisibleEntries = (insurerReportEntries ?? []).some(
    (entry: InsurerReportEntry) =>
      insurerReportEntryMetadataMap[entry.insurerReportEntryId]?.visible ===
      true
  );

  return (
    <Button
      data-help="insurer-reports-export-excel"
      appearance="subtle"
      icon={<DocumentTableRegular fontSize={24} />}
      disabled={insurerReportsLoadStatus === "loading" || !hasVisibleEntries}
      onClick={() => {
        refExcelExport.current?.save();
      }}
    >
      {t("greco.exportExcel")}
    </Button>
  );
};
